import { ModalRender } from "./modal-render";
import { ModalStateHandler } from "./modal-state-handler";
import { ModalHandler } from "./modal-handler";
import { ModalListener } from "./modal-listener";

type ModalSetupInstances = {
    render: ModalRender;
    state: ModalStateHandler;
    handler: ModalHandler;
    listener: ModalListener;
};

class ModalSetup {
    public static init(): ModalSetupInstances {
        const render = new ModalRender();
        const state = new ModalStateHandler();
        const handler = new ModalHandler(render, state);
        const listener = new ModalListener(handler, render);

        render.createModalStructure();
        listener.setup();

        return { render, state, handler, listener };
    }
}

export { ModalSetup };
